module.exports = __webpack_public_path__ + "img/start_game_morning.77ee2625.png";